import { createContext } from "react";

export const NotesEditorContext = createContext({ isDisplayDocViewer: false, onCloseDocViewer: () => {} });
